import React, { forwardRef, HTMLAttributes } from 'react';
import cn from 'classnames';

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
    fullWidth?: boolean;
}

const Layout = forwardRef<HTMLDivElement, LayoutProps>(
    ({ fullWidth, children, className, ...rest }, ref) => {
        const layoutClass = cn(
            'e-container',
            {
                '-full-width': fullWidth,
            },
            className,
        );
        return (
            <div className={layoutClass} ref={ref} {...rest}>
                {children}
            </div>
        );
    },
);

export { Layout, LayoutProps };
